class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variant-picker-variants]').textContent);

    this.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"], select')) this.handleChange();
    });

    this.updateAvailability();
  }

  getFieldsets() {
    return [...this.querySelectorAll('fieldset[data-option-position]')].sort(
      (a, b) => a.dataset.optionPosition - b.dataset.optionPosition
    );
  }

  getSelectedOptions() {
    return this.getFieldsets().map((fieldset) => fieldset.querySelector('input:checked, select')?.value);
  }

  findMatchingVariant(options) {
    return this.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
  }

  handleChange() {
    this.updateAvailability();

    const variant = this.findMatchingVariant(this.getSelectedOptions());
    if (!variant) return;

    this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
  }

  updateAvailability() {
    const options = this.getSelectedOptions();

    this.getFieldsets().forEach((fieldset) => {
      const position = Number(fieldset.dataset.optionPosition) - 1;

      fieldset.querySelectorAll('input[type="radio"], option').forEach((input) => {
        const candidate = [...options];
        candidate[position] = input.value;

        input.disabled = !this.variants.some(
          (variant) => variant.available && variant.options.every((value, index) => value === candidate[index])
        );
      });
    });
  }
}

// Guarded because this file is loaded both by the product section itself and
// globally by the quick-add modal - on an actual product page both copies
// load, and re-registering the same tag name throws.
if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}
